import(/* webpackMode: "eager", webpackExports: ["ImageGenerationSidePanel"] */ "/app/apps/sb-shell/app/(darkHeader)/ai/image-generation/_components/ImageGenerationSidePanel.tsx");
